import { http } from 'services'
// initial state
const state = () => ({
  general_settings: '',
  errors: null,
  all: []
})

// getters
const getters = {
}

// actions
const actions = {

  ['settings.getGeneralSettings'] ({commit, state}) {
    commit('CLEAR_ERRORS')
    return (http.get(`general-settings`))
    .then((res) => {
      commit('GET_GENERAL_SETTINGS', res);
    }).catch((res) => {
      commit('SETTINGS_ERROR', res);
    });
  },

  ['settings.getAllSettings'] ({dispatch, commit}, params = {}) {
    commit('CLEAR_ERRORS');

    return (http.get(`settings`)).then ((res) => {
      commit('GET_ALL_SETTINGS', res);
    }).catch ((res) => {
      commit('SETTINGS_ERROR', res);
    })
  },

  ['settings.updateSetting'] ({dispatch, commit, state}, {id, data}) {
    commit('CLEAR_ERRORS');

    return (http.put(`settings/${id}`, data))
    .then((res) => {
      commit('UPDATE_SETTING', res);
    }).catch((res) => {
      commit('SETTINGS_ERROR', res);
    })
  },

}

// mutations
const mutations = {

  GET_GENERAL_SETTINGS (state, res) {
    if(res)
      state.general_settings = res.data
  },

  GET_ALL_SETTINGS (state, res) {
    state.all = res.data;
  },

  UPDATE_SETTING (state, res) {
    res = res.data;
    const setting = state.all.find(s => s.id === res.id);
    if (setting) {
      setting.value = res.value;
    }
  },

  //ERRORS
  SETTINGS_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
